import React from 'react';
import { useHover } from "../../context/HoverContext";
import './FakeLink.css';

const FakeLink = ({ children, url, onClick, style }) => {
  const { setHoveredUrl } = useHover();

  return (
    <span
      className="fake-link"
      style={style}
      onMouseOver={() => setHoveredUrl(url)}
      onMouseOut={() => setHoveredUrl('')}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

export default FakeLink;